export const DATE_FORMAT = 'DD.MM.YYYY'

export const UI_DATE_FORMAT = 'DD MMMM YYYY'

export const UI_DATETIME_FORMAT = 'DD MMMM YYYY, HH:mm'

export const API_DATE_FORMAT = 'DD.MM.YYYY'
